import en from './en';
import zhCN from './zh-CN';
export default {
    en: en, // 英语
    zhCN: zhCN // 中文
};



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js